module.exports = __webpack_public_path__ + "img/jpg-dianpu@2x.950a9312.png";